import { create } from 'zustand';

interface EditModeState {
  isEditMode: boolean;
  enter: () => void;
  exit: () => void;
  toggle: () => void;
}

export const useEditModeStore = create<EditModeState>((set) => ({
  isEditMode: false,
  enter: () => set({ isEditMode: true }),
  exit: () => set({ isEditMode: false }),
  toggle: () => set((s) => ({ isEditMode: !s.isEditMode })),
}));
